module.exports = __webpack_public_path__ + "img/full7-min.52afa410.png";